import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { ThemeProvider } from './context/ThemeContext';
import { StrategyProvider } from './context/StrategyContext';
import { AuthProvider } from './context/AuthContext';
import { ProfileProvider } from './context/ProfileContext';
import { PortfolioProvider } from './context/PortfolioContext';
import { SSRProvider } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './dashboard-theme.css';
import './pages/page-theme-fixes.css';
import enforceTheme from './utils/themeEnforcer';

const App: React.FC = () => {
  // Initialize theme enforcer
  useEffect(() => {
    const observer = enforceTheme();
    
    // Clean up observer on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <SSRProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <ProfileProvider>
              <PortfolioProvider>
                <StrategyProvider>
                  <AppRoutes />
                </StrategyProvider>
              </PortfolioProvider>
            </ProfileProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </SSRProvider>
  );
};

export default App;
